import { roles } from "../../configs/constants";
import hacks from "../../configs/hacks";

export const getFiltersValuesApi = params => {
  const { state, apiUrl, startDateLabel, endDateLabel, emailsOfMyUsers, clientId, userInfos } = params;

  const currentFiltersToSend = { ...state.currentFilters };

  delete currentFiltersToSend[state.keyFilterSelected];
  if (state.keyFilterSelected === "period") {
    return apiUrl
      .post(`/range/${startDateLabel}/${endDateLabel}`, {
        match: currentFiltersToSend
      })
      .then((response = {}) => {
        return response.data;
      });
  } else {
    //const match = { ...currentFiltersToSend, user_email: { $in: emailsOfMyUsers } };
    const match = { ...currentFiltersToSend, user_email: { $in: emailsOfMyUsers }, client_id: clientId };
    //prevent from sending $in:[null]
    if (emailsOfMyUsers && emailsOfMyUsers.length === 1 && !emailsOfMyUsers[0]) {
      delete match.user_email;
    }

    //corepile/screlec specific filters
    if (userInfos.email === "corepile@upsell.fr") {
      match["salepoint.eo_piles"] = ["COREPILE", "SCRELEC; COREPILE"];
    }

    if (userInfos.email === "screlec@upsell.fr") {
      match["salepoint.eo_piles"] = ["SCRELEC", "SCRELEC; COREPILE"];
    }

    //hack
    const hacksInstance = hacks(userInfos, clientId);
    if (!hacksInstance.gallery.removeSectorLimitationToTerrain && userInfos.role_id === roles.TERRAIN) {
      match["sector.sector_id"] = userInfos.sectors.map(sector => sector.sector_id);
    }

    if (hacksInstance.gallery.selfContentOnlyToTerrain && userInfos.role_id === roles.TERRAIN) {
      match["user_email"] = [userInfos.email];
    }

    return apiUrl
      .post(`/distincts/${state.keyFilterSelected}`, {
        match: match
      })
      .then((response = {}) => {
        return response.data;
      });
  }
};



// WEBPACK FOOTER //
// src/redux/sagas/functionsApi.js